// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

import { useContext } from 'react';
import { SiteTimeContext, browserSiteTime, type SiteTimeValue } from '../contexts/SiteTimeContext';

/** Formatters on the active site's zone. Degrades to the viewer's zone unprovided; never throws. */
export function useSiteTime(): SiteTimeValue {
  return useContext(SiteTimeContext) ?? browserSiteTime;
}
